import { endOfDay, startOfDay, subDays } from "date-fns"

import { IGraphDateRange } from "src/components/Homes/DeviceDetails/Overview/DeviceGraphs"
import { useSearchParams } from "src/router/useSearchParams"

export function useAiAssistantAnalyticsParams() {
  const { searchParams, setSearchParamsAll } = useSearchParams({
    keys: [
      { key: "startDate", type: "string" },
      { key: "endDate", type: "string" },
    ],
  })

  const defaultStartDate = startOfDay(subDays(new Date(), 30))
  const defaultEndDate = endOfDay(new Date())

  const dateRange: IGraphDateRange = {
    startDate: searchParams.startDate
      ? new Date(searchParams.startDate)
      : defaultStartDate,
    endDate: searchParams.endDate
      ? new Date(searchParams.endDate)
      : defaultEndDate,
  }

  function setDateRange(newDateRange: IGraphDateRange) {
    setSearchParamsAll({
      startDate: newDateRange.startDate?.toISOString() ?? null,
      endDate: newDateRange.endDate?.toISOString() ?? null,
    })
  }

  return {
    dateRange,
    setDateRange,
  }
}
